import type { AppMeta } from "@calcom/types/App";

import _package from "./package.json";

export const metadata = {
  name: "Raiqa Video",
  description: _package.description,
  installed: !!process.env.DAILY_API_KEY,
  type: "daily_video",
  variant: "conferencing",
  url: "https://daily.co",
  categories: ["conferencing"],
  logo: "icon.svg",
  publisher: "Raiqa.health",
  category: "conferencing",
  slug: "daily-video",
  title: "Raiqa Video",
  isGlobal: true,
  email: "help@raiqa.health",
  appData: {
    location: {
      linkType: "dynamic",
      type: "integrations:daily",
      label: "Raiqa Video (No App needed)",
    },
  },
  key: { apikey: process.env.DAILY_API_KEY },
  dirName: "dailyvideo",
  isOAuth: false,
} as AppMeta;

export default metadata;
